const visibleDescriptionTextAttribute = 'description-text-visible';
const infoClickEventName = 'toujou-solr-description-card-info-click';
    
/**
 * Toggle the info bubble on the solr description cards
 */
class SolrCategoryCardInfo {
    constructor(card) {
        this.card = card;
        this.infoIcon = card.querySelector('.solr-category-card__info');
        this.descriptionEl = card.querySelector('.solr-category-card__description');
        this.closeButton = card.querySelector('.solr-category-card__description-close');
        this.state = false;

        this.infoIcon.addEventListener('click', this._handleInfoClick.bind(this));
        this.infoIcon.addEventListener('keyup', this._handleKeyUp.bind(this));
        this.closeButton.addEventListener('click', this._handleCloseButtonClick.bind(this));

        window.addEventListener(infoClickEventName, this._handleInfoClickEvent.bind(this));
    }

    /**
     * Toggle relevant attributes according to the state
     * @param value
     * @private
     */
    set _state(value) {
        this.state = value;

        if (this.state) {
            this.descriptionEl.setAttribute(visibleDescriptionTextAttribute, '');
            window.dispatchEvent(new CustomEvent(infoClickEventName, {
                detail: { el: this.card }
            }))
        } else {
            this.descriptionEl.removeAttribute(visibleDescriptionTextAttribute);
        }
    }

    get _state() {
        return this.state;
    }

    /**
     * Toggle the state when the description icon is clicked
     * @param event
     * @private
     */
    _handleInfoClick(event) {
        event.preventDefault();

        this._state = !this.state;
    }

    /**
     * Add key up event listeners to:
     *  - Toggle info panel on 'Space' or 'Enter' press
     *  - Close info panel on 'Escape' press
     * @param event
     * @private
     */
    _handleKeyUp(event) {
        event.preventDefault();
        if (event.key === 'Enter' || event.code === 'Enter' || event.code === 'Space' || event.key === ' ') {
            this._state = !this.state;
        }

        if (this._state && (event.key === 'Escape' || event.code === 'Escape')) {
            this._state = !this.state
        }
    }

    /**
     * Close the description when a description from another card opens
     * @param event
     * @private
     */
    _handleInfoClickEvent(event) {
        if (event.detail.el !== this.card) {
            this._state = false;
        }
    }

    /**
     * Close the description when the close button is clicked
     * @param event
     * @private
     */
    _handleCloseButtonClick(event) {
        event.preventDefault();

        this._state = false;
        this.closeButton.blur();
    }
}

/**
 * Get all solr category cards.
 * Initialize a SolrCategoryCardInfo instance for each card that has the relevant elements
 */
export function initSolrCategoryCardInfo() {
    const solrCategoryCards = document.querySelectorAll('.solr-category-card');
    if (!solrCategoryCards) return;

    solrCategoryCards.forEach((card) => {
        const infoIcon = card.querySelector('.solr-category-card__info');
        const descriptionText = card.querySelector('.solr-category-card__description');

        if (infoIcon && descriptionText) {
            new SolrCategoryCardInfo(card);
        }
    });
}